import type { WorkflowStepType } from '@/lib/api/generated/model';

/**
 * The condition a path carries, in words (spec 140 US6). A literal `true` is
 * how an author writes "always", and it read as code: on a linked step it
 * means the step continues once every task it created is done, which is the
 * thing worth saying.
 */
export function transitionCondition(
  when: string | null | undefined,
  stepKind: WorkflowStepType | undefined,
): string | null {
  const text = when?.trim();
  if (!text) return null;
  if (text.toLowerCase() !== 'true') return text;
  return stepKind === 'linked_workflow'
    ? 'Continues when all are done'
    : 'Always';
}
